export enum FeatureFlag {
  BILLING_USAGE_REVAMP = 'billing-usage-revamp'
}

export const localFeatureFlagValues = {
  [FeatureFlag.BILLING_USAGE_REVAMP]: false
};

export type FeatureFlags = typeof localFeatureFlagValues;

export const FEATURE_FLAG_OVERRIDES_STORAGE_KEY = 'ENV0_FEATURE_FLAG_OVERRIDES';

export const readFeatureFlagOverrides = (): Partial<FeatureFlags> => {
  try {
    const stored = localStorage.getItem(FEATURE_FLAG_OVERRIDES_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
